import React , {useEffect} from 'react'

function RecentGenerate(props) {
    const {recentGenerate,lastDate} = props;

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        recentGenerate();
        return () => {
          controller.abort();
        };
      }, []);

  return (
    <div style={{textAlign:'center'}} >
         {lastDate?.map((row)=>( `Last Generated Date : ${row.ledgerDate}` ))}
    </div>
  )
}

export default RecentGenerate